import { StyleSheet } from 'react-native';
import { Colors, grid } from '@shared/styles';

export const Styles = StyleSheet.create({
  urgentImage: {
    // Note(fant): px values taken from the original SVG from Figma
    width: 87,
    height: 145,
    alignSelf: 'center',
  },
  urgentBanner: {
    backgroundColor: Colors.gray.touch,
    borderRadius: grid(1),
  },
});
